<template>
    <div>
        <van-skeleton :row="10" row-width="100%"  style="margin-bottom: 10px;" :loading="loading">
            <div>
                <template v-if="infoData.code === 0">
                    <info :infoData="infoData"></info>
                </template>
                <template v-else-if="isFailed">
                    <div class="icon-wrap">
                        <img :src="$options.fail">
                        <p>{{_('身份认证失败,请重新扫码')}}</p>
                    </div>
                </template>
                <template v-else>
                    <div class="icon-wrap">
                        <img :src="$options.fail">
                        <p>{{_('身份认证已过期,请重新扫码')}}</p>
                    </div>
                </template>
            </div>
        </van-skeleton>
    </div>
</template>

<script>
    // import axios from 'axios'
    import { getParams } from '../utils'
    import Info from './info';
    import fail from '../../assets/fail.svg'
    import Cookies from 'js-cookie';
    import {FAILED, FAILED1, FAILED2} from '../const';

    export default {
        FAILED,
        FAILED1,
        FAILED2,
        fail,
        components:{
            Info
        },
        data () {
            return {
                loading: true,
                infoData: {},
                appId: ''
            };
        },
        computed: {
            isFailed(){
                return this.infoData.code === FAILED || this.infoData.code === FAILED1 || this.infoData.code === FAILED2
            }
        },
        mounted () {
            this._fetchData();
        },
        methods: {
            async _fetchData () {
                let rs = await this.axios.get(`/v1/sp-better/product-splist/${getParams()}`);
                this.appId = Cookies.get('appId');
                this.$emit('showView');
                this.infoData = rs.data;
                this.loading = false;
                document.title = this._('补丁包更新列表');
            },
        }
    }
</script>

<style scoped>
    .icon-wrap {
        padding: 30px 0 35px 0;

        text-align: center;
    }
    .icon-wrap > img {
        width: 88px;
        height: 88px;
    }
</style>
